// Avisos de apresentação ("veja: isto existe aqui") que a pessoa vê UMA vez e dispensa.
// Guardado no NAVEGADOR (localStorage), por conta: outra conta no mesmo navegador (ex.: recepção) também vê.
// É a base do tour guiado que vem depois — cada passo do tour vira um introId aqui.
//
// localStorage pode falhar (aba anônima, cota, bloqueio): aí vale a memória da aba, para o aviso não
// voltar a cada troca de tela; na próxima visita ele aparece de novo — preferível a nunca aparecer.

const PREFIX = 'agendario_intro_seen';
const memoria = new Set();

export function introKey(introId, userId) {
  return `${PREFIX}:${introId}:${userId || 'anon'}`;
}

function defaultStorage() {
  try { return typeof window !== 'undefined' ? window.localStorage : null; } catch { return null; }
}

/** true se este aviso já foi dispensado nesta conta, neste navegador. */
export function hasSeenIntro(introId, userId, storage = defaultStorage()) {
  const key = introKey(introId, userId);
  if (memoria.has(key)) return true;
  try { return storage?.getItem(key) != null; } catch { return false; }
}

/** Marca como visto (guarda quando foi). Devolve false se o navegador não deixou gravar. */
export function markIntroSeen(introId, userId, storage = defaultStorage(), now = new Date()) {
  const key = introKey(introId, userId);
  memoria.add(key);
  try { storage?.setItem(key, now.toISOString()); return true; } catch { return false; }
}

/** Só para teste: esquece a memória da aba. */
export function __resetIntroMemory() { memoria.clear(); }
